import { styled } from 'styled-components';
import { THEME } from '../../store/layout/layoutSlice';
import { Input } from '@devotel/design-system';

export const StyledInput = styled(Input)`
  ::placeholder {
    color: ${(props) =>
      props.theme === THEME.DARK ? '#F5F7F94A' : '#191C1E4A'};
  }
`;
